import { useEffect } from "react";
import Lenis from "lenis";
import { scrollToSection } from "../lib/scroll";

export const useLenis = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    const hash = window.location.hash.replace(/^#/, "");
    if (hash) requestAnimationFrame(() => scrollToSection(hash));
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only setup; Lenis/scrollToSection are module imports, the rest are browser globals or effect-local values
  }, []);
};
